export const STORAGE_KEY = 'voip-monitor-poor-quality';

/**
 * Thresholds for voip quality specified in task description
 * @see CUU2-2750: https://broadvoice-jira.atlassian.net/browse/CUU2-2750
 *
 * @see https://obkio.com/blog/measuring-voip-quality-with-mos-score-mean-opinion-score/
 *
 * ## 📌 Network Quality Factors and Their Impact:
 *
 * 1. Network Latency (RTT - Round Trip Time):
 *    - Measures the time taken for data to travel from source to destination and back
 *    - Critical for real-time voice communication
 *
 * 2. Jitter:
 *    - Variation in packet delay
 *    - Affects voice quality and can cause audio distortion
 *
 * 3. Packet Loss:
 *    - Percentage of data packets that fail to reach their destination
 *    - Can cause voice drops and audio quality degradation
 *
 * 4. Bitrate:
 *    - Minimum required bandwidth for acceptable voice quality
 *
 * Signal Strength Mapping (Icon States):
 *
 * | Signal Bars | RTT            | Jitter        | Packet Loss    | Min Bitrate   | Condition                         | Analytics Event                  |
 * |-------------|----------------|---------------|----------------|---------------|-----------------------------------|----------------------------------|
 * | 3 bars      | < 200ms        | < 40ms        | < 2%           | > 25kbps      | Good Connection                   | –                                |
 * | 2 bars      | 200-400ms      | 40-80ms       | 2-5%           | > 15kbps      | Weak Connection                   | –                                |
 * | 1 bar       | > 400ms        | > 80ms        | > 5%           | < 15kbps      | Poor Connection                   | "On call - poor connection"      |
 * | 0 bars      | –              | –             | –              | –             | No WebRTC connection detected     | "On call - no connection"        |
 *
 */